<template>
  <input
    ref="kinput"
    v-model="inputvalue"
    class="kbutton"
    :style="styled"
    :type="type"
    :maxlength="maxLength"
    :disabled="isDisable"
    @focus="focus($event)"
    @blur="focus($event)"
    @keyup="onKeyUp($event)"
  >
</template>

<script>
export default {
	mixins: [global],
	props: {
		formatMoney: {
			type: Boolean,
			default: false,
		},
		mask: {
			type: String,
			default: '',
		},
		maxLength: {
			type: Number,
			default: null,
		},
		alive: {
			type: Boolean,
			default: true,
		},
		isDisable: {
			type: Boolean,
			default: false,
		},
		icon: {
			type: Object,
			default: () => ({
				type: 'filter',
				size: '14px',
				color: '#000000',
			}),
		},
		value: {
			type: [String, Number],
			default: '',
		},
		type: {
			type: String,
			default: 'text',
		},
		title: {
			type: String,
			default: 'Filtros',
		},
		fontSize: {
			type: String,
			default: '12px',
		},
		backgroundColor: {
			type: String,
			default: '#FFF',
		},
		marginLeft: {
			type: String,
			default: '0px',
		},
		marginRight: {
			type: String,
			default: '0px',
		},
		borderRadius: {
			type: String,
			default: '10px',
		},
		boxSizing: {
			type: String,
			default: 'border-box',
		},
		width: {
			type: String,
			default: '100px',
		},
		height: {
			type: String,
			default: '30px',
		},
		borderWidth: {
			type: String,
			default: '1px',
		},
		borderStyle: {
			type: String,
			default: 'solid',
		},
		borderColor: {
			type: String,
			default: '#cecece',
		},
		borderFocused: {
			type: String,
			default: '#e85d04',
		},
		validationParams: {
			type: Object,
			default: () => ({ format: null }),
		},
		letterSpacing: {
			type: String,
			default: '0',
		},
		display: {
			type: String,
			default: 'flex',
		},
		alignItems: {
			type: String,
			default: 'center',
		},
		justifyContent: {
			type: String,
			default: 'center',
		},
		fontFamily: {
			type: String,
			default: 'Sora, sans-serif !important',
		},
		fontWeight: {
			type: String,
			default: 'bold',
		},
		paddingRight: {
			type: String,
			default: '0px',
		},
		paddingLeft: {
			type: String,
			default: '10px',
		},
	},
	data() {
		return {
			isFocused: false,
			inputvalue: this.value,
			valueFormated: '',
			lastStr: [],
		};
	},
	computed: {
		styled() {
			return {
				fontSize: this.fontSize,
				backgroundColor: this.isDisable ? '#ececec' : this.backgroundColor,
				borderRadius: this.borderRadius,
				width: this.width,
				height: this.height,
				borderWidth: this.borderWidth,
				borderStyle: this.borderStyle,
				borderColor: this.isFocused === true ? this.borderFocused : this.borderColor,
				display: this.display,
				alignItems: this.alignItems,
				fontFamily: this.fontFamily,
				fontWeight: this.fontWeight,
				justifyContent: this.justifyContent,
				letterSpacing: this.letterSpacing,
				marginLeft: this.marginLeft,
				marginRight: this.marginRight,
				paddingRight: this.paddingRight,
				paddingLeft: this.paddingLeft,
				boxSizing: this.boxSizing,
			};
		},
		formatedValue() {
			return this.valueFormated;
		},
	},
	watch: {
		inputvalue() {
			this.validate();
		},
	},
	created() {
		this.$emit('value', this.inputvalue);
	},
	activated() {
		if (this.alive === true) {
			this.inputvalue = '';
		}
	},
	methods: {
		validate() {
			if (this.validationParams.format) {
				switch (this.validationParams.format) {
				case 'email':
					this.validateEmail();
					break;
				case 'userName':
					this.validateUsername();
					break;
				default:
					break;
				}
			}
		},
		focus() {
			this.isFocused = !this.isFocused;
		},
		onKeyUp() {
			switch (this.mask) {
			case 'cpfcpnj':
				if (this.inputvalue.length > 14) {
					this.inputvalue = this.maskCNPJ(this.inputvalue);
				} else {
					this.inputvalue = this.maskCPF(this.inputvalue);
				}
				break;
			case 'cpf':
				this.inputvalue = this.maskCPF(this.inputvalue);
				break;
			case 'lastdigits':
				this.inputvalue = this.lastDigits(this.inputvalue);
				break;
			default:
				break;
			}
			this.$emit('value', this.inputvalue);
		},
		maskCNPJ(v) {
			// eslint-disable-next-line
			v = v.replace(/\D/g, '');
			// eslint-disable-next-line
			v = v.replace(/^(\d{2})(\d)/, '$1.$2');
			// eslint-disable-next-line
			v = v.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
			// eslint-disable-next-line
			v = v.replace(/\.(\d{3})(\d)/, '.$1/$2');
			// eslint-disable-next-line
			v = v.replace(/(\d{4})(\d)/, '$1-$2');
			// eslint-disable-next-line
			return v;
		},
		lastDigits(digits) {
			if (digits.length > 4) {
				const removeStr = digits.length - 4;
				return digits.slice(0, -Math.abs(removeStr));
			}
			return digits;
		},
		maskCPF(mcpf) {
			// eslint-disable-next-line
			mcpf = mcpf.replace(/\D/g, '');
			// eslint-disable-next-line
			mcpf = mcpf.replace(/(\d{3})(\d)/, '$1.$2');
			// eslint-disable-next-line
			mcpf = mcpf.replace(/(\d{3})(\d)/, '$1.$2');
			// eslint-disable-next-line
			mcpf = mcpf.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
			return mcpf;
		},
		sendValidateMessage(message) {
			this.$emit('validation-msg', message);
		},
		validateEmail() {
			const email = this.inputvalue;
			// eslint-disable-next-line
			const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			if (re.test(email) === false) {
				this.sendValidateMessage('Email digitado não é válido!');
				this.$emit('validation-error', true);
			} else {
				this.sendValidateMessage('');
				this.$emit('validation-error', false);
			}
			return re.test(email);
		},
		validateUsername() {
			let error = '';
			const illegalChars = /\W/; // allow letters, numbers, and underscores
			const str = this.inputvalue;
			if (str === '') {
				error = 'Digite o nome de usuário';
				this.sendValidateMessage('Digite o nome de usuário');
				this.$emit('validation-error', true);
			} else if (str.length < 5 || str.length > 15) {
				error = 'O nome de usuário deve ter de 5 a 15 caracteres';
				this.sendValidateMessage('O nome de usuário deve ter de 5 a 15 caracteres');
				this.$emit('validation-error', true);
			} else if (illegalChars.test(str)) {
				error = 'Por favor, insira um nome de usuário válido. Use apenas números e letras';
				this.sendValidateMessage(
					'Por favor, insira um nome de usuário válido. Use apenas números e letras'
				);
				this.$emit('validation-error', true);
			} else {
				this.sendValidateMessage('');
				this.$emit('validation-error', false);
			}
			return error;
		},
	},
};
</script>

<style scoped>
.kbutton {
	all: unset;
	transition: 150ms ease-in-out;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

/* Firefox */
input[type='number'] {
	-moz-appearance: textfield;
}
</style>
